// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeHomepageGetBody = {};

export type typeHomepageGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    iosStoreUrl?: string;
    androidStoreUrl?: string;
    facebookUrl?: string;
    xUrl?: string;
    instagramUrl?: string;
    recaptchaSiteKey?: string;
  };
};

export type typeHomepageGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeHomepageGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeHomepageGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaHomepageGetBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createHomepageGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaHomepageGetBody);
  }

  return async function postHomepageGet(
    payload: typeHomepageGetBody,
  ): Promise<typeHomepageGetOutput200 | typeHomepageGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postHomepageGet" failed before calling the network. #e44888e406c0`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e44888e406c0" },
        },
        data: null,
      } as typeHomepageGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/homepage/get`,
      httpMethod: "POST",
      options,
    })) as typeHomepageGetOutput200 | typeHomepageGetOutput400;
  };
}
